<div class="tracking-item-container" [ngStyle]="{ width: width }" style="width: calc(12.5%)">
    <div class="tracking-item-info-container">
        <div class="tracking-item-label" [title]="trackingStep.label">{{ trackingStep.label }}</div>
        <div class="tracking-item-icon-container">
            <i
                [ngClass]="{ opacity_off: trackingStep.state !== TrackingItemStateEnum.NotStarted, opacity_on: trackingStep.state === TrackingItemStateEnum.NotStarted }"
                class="fas fa-folder opacity_off tracking-item-icon">
                @if (trackingStep.icon) {
                    <img src="data:image/png;base64,{{ trackingStep.icon }}" [style]="trackingStep.color" />
                }
            </i>
        </div>

        <div class="tracking-item-state">{{ trackingStep.stepStateName }}</div>

        <div *ngIf="trackingStep.state === TrackingItemStateEnum.Completed" class="ng-scope tracking-item-status">
            <fa-icon [icon]="checkIcon" class="check_valid"></fa-icon>
        </div>
        <div *ngIf="trackingStep.state !== TrackingItemStateEnum.Completed" class="ng-scope tracking-item-status-empty"></div>
    </div>
</div>
